
const CrudCodeValues = require("./CrudCodeValues");
module.exports = {
    EXT: "EXT",
    NPH: "NPH",
    MET: "MET",
    ANI: "ANI",
    HUM: "HUM",
    CBT: "CBT",
    MNU: "MNU",
    INT: "INT",
    DYS: "DYS",
    HET: "HET",
    VIB: "VIB"
};
